import { jsx, jsxs } from 'react/jsx-runtime';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '../ui/alert.js';
import '@radix-ui/react-avatar';
import '../ui/badge.js';
import 'lucide-react';
import 'react';
import 'react-day-picker';
import '../ui/button.js';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '../ui/time-input.js';
import '@radix-ui/react-separator';
import '../ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import '@clerk/clerk-react';
import '../../lib/toast.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../form/RichTextEditor.js';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

function FormPageLayout({ children, className }) {
    return jsx("div", { className: cn('flex flex-col flex-1 min-h-0', className), children: children });
}
function Header({ children, className }) {
    return (jsx("div", { className: cn('shrink-0 bg-card border-b px-4 sm:px-6 py-3 sm:py-4 min-h-[65px] flex items-center', className), children: jsx("div", { className: "flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4 w-full", children: children }) }));
}
function Content({ children, maxWidth = '4xl', className }) {
    const maxWidthClass = {
        sm: 'max-w-sm',
        md: 'max-w-md',
        lg: 'max-w-lg',
        xl: 'max-w-xl',
        '2xl': 'max-w-2xl',
        '3xl': 'max-w-3xl',
        '4xl': 'max-w-4xl',
        '5xl': 'max-w-5xl',
        '6xl': 'max-w-6xl',
        '7xl': 'max-w-7xl',
        full: 'max-w-full',
    }[maxWidth] ?? 'max-w-4xl';
    return (jsx("div", { className: cn('bg-background flex-1 min-h-0 overflow-auto p-4 sm:p-6', className), children: jsx("div", { className: cn('mx-auto space-y-6', maxWidthClass), children: children }) }));
}
function formatLastSaved(date) {
    const dateStr = date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
    const timeStr = date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
    });
    return `Last saved: ${dateStr} at ${timeStr}`;
}
function Footer({ children, maxWidth = '4xl', className, lastSaved }) {
    const maxWidthClass = {
        sm: 'max-w-sm',
        md: 'max-w-md',
        lg: 'max-w-lg',
        xl: 'max-w-xl',
        '2xl': 'max-w-2xl',
        '3xl': 'max-w-3xl',
        '4xl': 'max-w-4xl',
        '5xl': 'max-w-5xl',
        '6xl': 'max-w-6xl',
        '7xl': 'max-w-7xl',
        full: 'max-w-full',
    }[maxWidth] ?? 'max-w-4xl';
    return (jsx("div", { className: cn('shrink-0 bg-card border-t px-4 sm:px-6 py-3', className), children: jsxs("div", { className: cn('flex flex-col sm:flex-row items-center justify-between gap-3 mx-auto', maxWidthClass), children: [jsx("div", { className: "text-sm text-muted-foreground", children: lastSaved && formatLastSaved(lastSaved) }), children] }) }));
}
/* ── Attach sub-components ──────────────────────────────────────────────── */
FormPageLayout.Header = Header;
FormPageLayout.Content = Content;
FormPageLayout.Footer = Footer;

export { FormPageLayout };
//# sourceMappingURL=FormPageLayout.js.map
